module.exports = "nav ul.nav li.nav-item a {\n  cursor: pointer; }\n"